import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import overlay from "../images/overlay.png";

const FSVideoContainer = styled.div`
  ${""} ${"" /*
  NOTE: Emulates Jarallax behavior
  */} position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  visibility: hidden;
  z-index: -100;

  /* NOTE: This is the key to fixed-position video backgrounds! */
  clip: rect(0 100vw 100vh 0);
`;

const ZIndexedHero = styled.div`
  position: relative;
  z-index: 0;
  background: transparent none scroll;
  background-size: auto auto;
`;

const HeroBodyWithOverlay = styled.div`
  background-image: url('${overlay}');
  background-repeat: tile;
`;

const StyledVideo = styled.video`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  max-width: none;
  max-height: none;
  min-width: 100vw;
  min-height: 100vh;
  visibility: visible;
  margin: 0 0 0 auto;
  opacity: 0.3;
  z-index: -100;
  background-position: 50% 50%;
  background-position-x: 50%;
  background-position-y: 50%;
  ${"" /* NOTE: Won't work in IE!
      TODO: Find workaround */} object-fit: cover;
`;

const HeroWithVideo = props => (
  <ZIndexedHero
    {...props}
    className={`hero is-${props.color} is-${props.size}`}
  >
    <HeroBodyWithOverlay className="hero-body">
      {props.children}
    </HeroBodyWithOverlay>
  </ZIndexedHero>
);

HeroWithVideo.propTypes = {
  color: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

class HeroVideo extends Component {
  static propTypes = {
    poster: PropTypes.string,
    src: PropTypes.string.isRequired
  };

  state = {
    videoSource: []
  };

  componentWillMount() {
    this.setState({
      videoSource: this.props.src
    });
  }

  componentWillUnmount() {
    this.setState({
      videoSource: []
    });
  }

  render() {
    return (
      <FSVideoContainer>
        <StyledVideo loop autoPlay muted poster={this.props.poster}>
          <source src={this.state.videoSource} />
        </StyledVideo>
      </FSVideoContainer>
    );
  }
}

export default HeroVideo;
export { HeroWithVideo };



// WEBPACK FOOTER //
// ./src/components/HeroVideo.js